import { useEffect, useState } from 'react';

const FetchWordPressCats = () => {
	const [cats, setCats] = useState([]);
	const [catsLoading, setCatsloading] = useState(true);
	const [catsError, setCatsError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch('https://alliedretailprop.com/wp-json/wp/v2/prop_type?orderby=id');
				if (!response.ok) {
					throw new Error(`HTTP error: ${response.status}`);
				}

				const data = await response.json();
				setCats(data);
			} catch (err) {
				setCatsError(err.message);
			} finally {
				setCatsloading(false);
			}
		};

		fetchData();
	}, []); // Empty array = run once on mount

	return { cats, catsLoading, catsError };
}

export default FetchWordPressCats;
